<template>
  <div>
    <banner-top :text="titletext"></banner-top>
    <div class="courseImg">
      <el-carousel trigger="click" height="150px">
        <el-carousel-item v-for="item in cover" :key="item.id">
          <img style="height:100%" :src="item" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="coursetitle">
        <div>
            {{res.title}}
        </div>
        <el-divider></el-divider>
        <div class="timeStartoEnd">
          <img src="../assets/icon43.png" alt="">
          <span v-if="res.start_date===res.end_date">{{res.start_date}}</span>
          <span v-else>{{res.start_date}} ~ {{res.end_date}}</span>
        </div>
        <el-divider></el-divider>
        <div class="time" v-for="(item, key) in res.schedules" :key="item.id">
            <div>
              <img src="../assets/icon44.png" alt="">
            </div>
            <div class="date">
              <div class="YTD">{{key}}</div>
              <div class="allHour">
                <div class="hour" v-for="item in item" :key="item.id">{{item}}</div>
              </div>
            </div>
        </div>
    </div>
    <div class="interval"></div>
    <div class="introduce">
        <span>课程介绍</span>
        <el-divider></el-divider>
        <!-- <div>{{res.brief}}</div> -->
        <div v-for="item in detail" :key="item.id" class="detail">
          <img :src="item" alt="">
        </div>
    </div>
    <div style="height: 3rem;"></div>
    <div v-if="!coursesNumber">
      <div v-if="lectureAvailable" class="nav">
          <button class="navNone">暂无报名名额</button>
      </div>
      <div v-else class="nav">
        <button class="navNone">课程已结束</button>
      </div>
    </div>
    <div v-else>
      <div v-if="lectureAvailable" class="nav">
        <span>￥{{res.price}}</span>
        <button @click="toBooking">我要报名</button>
      </div>
      <div v-else class="nav">
        <button class="navNone">课程已结束</button>
      </div>
    </div>
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'

export default {
  name: 'courseDetail',
  components: { bannerTop },
  data () {
    return {
      titletext: '详情页',
      res: Object,
      id: '',
      cover: Array,
      detail: Array,
      lectureAvailable: true,
      coursesNumber: true
    }
  },
  mounted () {
    http['get'](`lectures/${this.$route.query.id}`).then((res) => {
      this.id = this.$route.query.id
      this.res = res
      this.cover = res.cover_images
      this.detail = res.detail_images
      let mytime = res.end_date
      let dateTmp = mytime.replace(/-/g, '/')
      let timestamp = Date.parse(dateTmp)
      let now = new Date().getTime()
      console.log(timestamp)
      console.log(now)
      if (timestamp < now) {
        this.lectureAvailable = false
      }
    })
    http['get'](`lectures/${this.$route.query.id}/dates`).then((res) => {
      if (res.dates.length === 0) {
        this.coursesNumber = false
      } else {
        this.coursesNumber = true
      }
    })
  },
  methods: {
    toBooking: function () {
      this.$router.push({name: 'booking', query: {id: this.id}})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.courseImg img{
    width: 100%;
}
.coursetitle {
    margin: 0.8rem;
}
.coursetitle img{
    width: 1rem;
    height: 1rem;
}
.el-divider{
   margin: 1rem 0;
}
.coursetitle span{
    color: #666;
    margin-right: 0.2rem;
}
.interval {
    width: 100%;
    height: 2rem;
    background: #f5f5f5;
}
.timeStartoEnd span {
  position: relative;
  top: -0.1rem;
  font-weight: 700;
}
.time {
  display: flex;
  margin: 0.2rem 0;
}
.time .date{
  display: flex;
  margin-top: -0.1rem;
}
.YTD {
  margin: 0 2rem 0 0.2rem;
  font-weight: 700;
}
.allHour {
  display: flex;
  flex-wrap: wrap;
  width: 13rem;
}
.hour {
  margin: 0 0.2rem;
}
.introduce {
    margin: 0.8rem;
}
.introduce div{
    color: #666;
    text-align: center;
}
.introduce img{
    text-align: center;
    width: 100%;
}
.detail {
  margin-top: -4px;
  padding: 0;
}
.detail img{
  margin: 0;
  padding: 0;
}
.nav {
  width: 100%;
  height: 3rem;
  display: flex;
  position:fixed;
  bottom: 0;
  background: #fff;
  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.2);
}
.navNone {
  background: #999!important;
}
.nav span {
    flex: 1;
    font-size: 20px;
    margin: 0.8rem;
    color: #ff0101;
}
.nav button {
    flex: 4;
    margin: 0.4rem 0.8rem ;
    width: 10rem;
    height: 2.2rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    color: #fff;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/class/courseDetail.vue